import React from 'react';
export const Banner32DataSource = {
  wrapper: { className: 'banner3' },
  textWrapper: {
    className: 'banner3-text-wrapper',
    children: [
      {
        name: 'nameEn',
        className: 'banner3-name-en l5m2vfpnx5h-editor_css',
        children: (
          <span>
            <p>Seeking Experience &amp; Keep you in my heart</p>
          </span>
        ),
      },
      {
        name: 'slogan',
        className: 'banner3-slogan l5m2tw7orq9-editor_css',
        children: '专业源于专注 服务成就品牌',
        texty: true,
      },
      {
        name: 'name',
        className: 'banner3-name',
        children: (
          <span>
            <p>始终如一的为您提供帮助</p>
          </span>
        ),
      },
      {
        name: 'button',
        className: 'banner3-button l5m2ukn6ge-editor_css',
        children: (
          <span>
            <span>
              <p>服务支持</p>
            </span>
          </span>
        ),
      },
      {
        name: 'time',
        className: 'banner3-time',
        children: (
          <span>
            <span>
              <p>@江西融云网络科技有限公司</p>
            </span>
          </span>
        ),
      },
    ],
  },
};
export const Content00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper l5m6sme3sla-editor_css',
  },
  page: { className: 'home-page content0 l5m77y5nmtp-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'image~l5m7b8jig4a',
        className: '',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
      },
      {
        name: 'title',
        children: (
          <span>
            <p>服务与支持</p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper l5lwmvs1p5k-editor_css',
    children: [
      {
        name: 'block0',
        className: 'content0-block l5qe7rolwdc-editor_css',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item l5qe4heoeth-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                require('../static/组建/服务图标.png'),
            },
            {
              name: 'title',
              className: 'content0-block-title l5m3k55g7kr-editor_css',
              children: (
                <span>
                  <p>服务类型</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>软件开发、技术服务、软硬件整体解决方案</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block l5qe9bfrmv-editor_css',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item l5qeenqygkr-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                require('../static/组建/服务图标.png'),
            },
            {
              name: 'title',
              className: 'content0-block-title l5m3kdxief-editor_css',
              children: (
                <span>
                  <p>培训方式</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>线上、线下双线集中培训及个别辅助</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block l5qea1bd6z8-editor_css',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item l5qefef1v7-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                require('../static/组建/服务图标.png'),
            },
            {
              name: 'title',
              className: 'content0-block-title l5m3khstscq-editor_css',
              children: (
                <span>
                  <p>保障维护</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>全天24小时响应快速诊断及解决</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~l5lwo985o2n',
        className: 'content0-block l5qe8ieq28p-editor_css',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item l5qefjnxke-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                require('../static/组建/服务图标.png'),
            },
            {
              name: 'title',
              className: 'content0-block-title l5m3knv7umo-editor_css',
              children: (
                <span>
                  <span>
                    <p>定制质询</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <span>
                      <p>快速设计方案应需快速组织团队</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Feature30DataSource = {
  wrapper: {
    className: 'home-page-wrapper content3-wrapper l5qdxym6jhh-editor_css',
  },
  page: { className: 'home-page content3' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>意见反馈</p>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: (
          <span>
            <p>7*24小时响应快速诊断及解决</p>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content3-block',
        md: 12,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon l5qdw96u9i-editor_css',
            children:
              require("../static/hover/fwzc_3.jpg"),
          },
          textWrapper: { className: 'content3-text l5qdwyb1ca-editor_css' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>微信公众号</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <p>融云网络科技有限公司官方指定微信公众号</p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block1',
        className: 'content3-block',
        md: 12,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon l5qdwhsu9sh-editor_css',
            children:
               require("../static/hover/fwzc_2.jpg"),
          },
          textWrapper: { className: 'content3-text l5qdy207rid-editor_css' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>联系电话</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <span>
                  <p>
                    联系电话：0792-8159222<br />
                    联系电话：17770299988<br />
                    <br />公司地址：江西省九江市濂溪区十里老街C4栋4层1499号
                  </p>
                </span>
              </span>
            ),
          },
        },
      },
    ],
  },
};
